import useCustomHook from '@/hooks/useCustomHook';
import { useEffect } from 'react';

export default function useSortImagesConf({ data, setConf = () => {} }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      questionsPerScreen: 4,
      showBestStudents: true,
      questionTimer: 30,
      resultsTimer: 10,
    },
    actions: {
      setValue: (field, value) => {
        actions.setState({ [field]: value });
      },
    },
  });

  useEffect(() => {
    setConf(state);
  }, [state]);

  useEffect(() => {
    actions.setState({ questionsPerScreen: data?.questionsPerScreen || 4 });
  }, [data?.questionsPerScreen]);

  return { state, actions };
}
